import React, { useRef, useLayoutEffect } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5radar from "@amcharts/amcharts5/radar";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
var MyGlobalObject = {}
var PreviousAngles = {}

function CompassChart(props) {
    const chart = useRef(null);
    const root = useRef(null);
    const id = props.id;
    const div = props.div;
    //console.log(props.id, MyGlobalObject[id])

    useLayoutEffect(() => {
        if (props.value === undefined) return;

        if (MyGlobalObject[id]) {
            MyGlobalObject[id].dispose();
        }

        const r = am5.Root.new(div);
        r.setThemes([am5themes_Animated.new(r)]);

        const chart = r.container.children.push(
            am5radar.RadarChart.new(r, {
                panX: false,
                panY: false,
                startAngle: -90,
                endAngle: 270
            })
        );

        const axisRenderer = am5radar.AxisRendererCircular.new(r, {
            strokeOpacity: 1,
            strokeWidth: 5,
            minGridDistance: 10
        });
        axisRenderer.ticks.template.setAll({ forceHidden: true });
        axisRenderer.grid.template.setAll({ forceHidden: true });
        axisRenderer.labels.template.setAll({ forceHidden: true });

        const xAxis = chart.xAxes.push(
            am5xy.ValueAxis.new(r, {
                maxDeviation: 0,
                min: 0,
                max: 360,
                strictMinMax: true,
                renderer: axisRenderer
            })
        );
        
        const axisDataItemN = xAxis.makeDataItem({ value: 0 });
        const clockHandN = am5radar.ClockHand.new(r, {
            pinRadius: 0,
            radius: am5.percent(90),
            bottomWidth: 10
        });
        clockHandN.hand.set("fill", am5.color(0xff0000));
        clockHandN.adapters.add("rotation", () => -90);
        axisDataItemN.set("bullet", am5xy.AxisBullet.new(r, { sprite: clockHandN }));
        xAxis.createAxisRange(axisDataItemN);

        const axisDataItemS = xAxis.makeDataItem({ value: 180 });
        const clockHandS = am5radar.ClockHand.new(r, {
            pinRadius: 0,
            radius: am5.percent(90),
            bottomWidth: 10
        });
        clockHandS.adapters.add("rotation", () => 90);
        axisDataItemS.set("bullet", am5xy.AxisBullet.new(r, { sprite: clockHandS }));
        xAxis.createAxisRange(axisDataItemS);

        function createLabel(text, value, tickOpacity) {
            const axisDataItem = xAxis.makeDataItem({ value });
            xAxis.createAxisRange(axisDataItem);
            axisDataItem.get("label").setAll({
                text,
                forceHidden: false,
                inside: true,
                radius: 20
            });
            axisDataItem.get("tick").setAll({
                forceHidden: false,
                strokeOpacity: tickOpacity,
                length: 12 * tickOpacity,
                visible: true,
                inside: true
            });
        }

        ["N", "NE", "E", "SE", "S", "SW", "W", "NW"].forEach((label, i) => 
            createLabel(label, i * 45, 1)
        );
        for (let i = 0; i < 360; i += 5) {
            createLabel("", i, 0.5);
        }

        const newAngle = 270 - props.value;
        const prevAngle = PreviousAngles[id];

        if (prevAngle === undefined) {
            chart.set("startAngle", newAngle);
            chart.set("endAngle", newAngle + 360);
            axisDataItemN.set("value", am5.math.normalizeAngle(newAngle));
            //axisDataItemS.set("value", am5.math.normalizeAngle(newAngle));
        } else {
            chart.set("startAngle", prevAngle);
            chart.set("endAngle", prevAngle + 360);
            axisDataItemN.set("value", am5.math.normalizeAngle(prevAngle));
            //axisDataItemS.set("value", am5.math.normalizeAngle(prevAngle));
            
            chart.animate({ key: "startAngle", to: newAngle, duration: 800, easing: am5.ease.out(am5.ease.cubic) });
            chart.animate({ key: "endAngle", to: newAngle + 360, duration: 800, easing: am5.ease.out(am5.ease.cubic) });
            axisDataItemN.animate({ key: "value", to: am5.math.normalizeAngle(newAngle), duration: 800, easing: am5.ease.out(am5.ease.cubic) });
            //axisDataItemS.animate({ key: "value", to: am5.math.normalizeAngle(newAngle), duration: 800, easing: am5.ease.out(am5.ease.cubic) });
        }

        PreviousAngles[id] = newAngle;
        chart.appear(0, 0);
        MyGlobalObject[id] = r;

/* 
        setInterval(function () {
            var newAngle = Math.random() * 360;
            chart.animate({
                key: "startAngle",
                to: newAngle,
                duration: 1000,
                easing: am5.ease.out(am5.ease.cubic)
            });
            chart.animate({
                key: "endAngle",
                to: newAngle + 360,
                duration: 1000,
                easing: am5.ease.out(am5.ease.cubic)
            });
            axisDataItemN.animate({
                key: "value",
                to: am5.math.normalizeAngle(-90 - newAngle),
                duration: 1000,
                easing: am5.ease.out(am5.ease.cubic)
            });
            axisDataItemS.animate({
                key: "value",
                to: am5.math.normalizeAngle(90 - newAngle),
                duration: 1000,
                easing: am5.ease.out(am5.ease.cubic)
            });
        }, 2000);
 */
        return () => {
            if (MyGlobalObject[id]) {
                MyGlobalObject[id].dispose();
            }
        };


    }, [props.value]);
    return (
        <div id={div} style={{ width: "100%", height: "300px" }}></div>
    );

}

export default CompassChart;